export default function TrustedCertified() {
  const services = [
    {
      icon: '/hse.png',
      title: 'Corporate Security',
      link: '/building-maintenance',
      desc: 'Many organizations need temporary security services from time to time. Whether you need emergency security services, event security services.',
    },
    {
      icon: '/ssip.png',
      title: 'Industrial & Warehouse',
      link: '/building-maintenance',
      desc: 'Our clients trust us to deliver the highest quality standards every day at every location across all industries we serve. We do this through our tailored security.',
    },
    {
      icon: '/cscs.png',
      title: 'Integrated Security',
      link: '/Integrated Security',
      desc: 'Are you confident your facilities and assets are secure when you’re not there? Without integrating the security risks increase rather than go down.',
    },
  ];
  return (
    <div className="mt-[0rem] flex w-full justify-center bg-[#121212] py-[4rem] font-inter md:mt-[6rem]">
      <div className="flex w-full max-w-[114rem] flex-col items-stretch justify-center gap-[0rem] px-[2rem]">
        {/* ===== HEADING ===== */}
        <div className="flex flex-col items-center text-center">
          <h1 className="text-[2.6rem] font-[600] leading-[3.38rem] text-white">
            We Are <span className="text-[#0ec9ac]">Trusted</span>, Certified
          </h1>
        </div>

        {/* ===== SMALL SERVICES GRID ===== */}
        <div className="flex w-full flex-wrap items-center justify-center gap-x-[5rem] gap-y-[2rem] py-[4rem]">
          {services.map((item, index) => (
            <>
              {' '}
              {index < 3 && (
                <div key={index} className="flex h-[12.3rem] justify-center rounded-md">
                  <img src={item.icon} alt={item.title} className="h-auto w-full" />
                </div>
              )}
            </>
          ))}
        </div>
      </div>{' '}
    </div>
  );
}
